import React from "react"
import PropTypes from "prop-types"
import Members from "@components/project/members"
import Wrap from "../components/secondary/wrap"
import Back from "../components/secondary/back"
import Title from "../components/secondary/title"
import Tabs from "../components/secondary/tabs"
import 'styled-components/macro'

const MAX_TITLE_LENGTH = 45

const ProjectNav = ({ title, _id, canEdit, folder }) => (
  <Wrap>
    <React.Fragment>
      <Back
        to={folder ? `/projects/folder/${folder.slug}` : `/projects`}
        tooltip={folder ? `Back to ${folder.title}` : "Back to all projects"}/>
      <Title small='Project' main={title && title.length > MAX_TITLE_LENGTH ? title.substring(0, MAX_TITLE_LENGTH) + "..." : title}/>
      <Tabs
        tabs={[
          { to: "/projects/" + _id + "/files", label: "Project Files", visible: true },
          { to: "/projects/" + _id + "/requests", label: "File Requests", visible: true },
          { to: "/projects/" + _id + "/screeners", label: "Screeners", visible: true },
          { to: "/projects/" + _id + "/details", label: "Details", visible: canEdit }
        ].filter(({ visible }) => visible)}/>
      <div className='flex flex-auto items-center justify-end'>
        <Members/>
      </div>
    </React.Fragment>
  </Wrap>
)

ProjectNav.propTypes = {
  _id: PropTypes.string,
  title: PropTypes.string,
  projectLoading: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  folder: PropTypes.any
}

export default ProjectNav
